export default {
  Navigation: {
    retract: '收起導航',
    opennav: '展開導航',
    app: '應用',
    workbench: '工作臺',
    complete: '完成',
    commonly: '常用設置',
    myCommonly: '我的常用',
    appDragApp: '按住拖動排序，最多可添加8個',
    system: '系統模塊',
    cApp: '機構應用',
    goAdd: '去添加',
    editPwd: '修改密碼',
    determine: '確定',
    cancel: '取消',
    mail: '未讀郵件',
    allRead: '全部標為已讀',
    viewAll: '查看全部',
    notification: '消息通知',
    help: '幫助文檔',
    suggest: '建議反饋',
    viode: '視頻教程',
    guide: '新手引導',
    preferences: '偏好設置',
    personal: '個人設置',
    gobackend: '系統後臺設置',
    exit: '退出',
    selectColor: '選擇顏色',
    customColors: '自定義顏色',
    Tips: '提示',
    Dear: '尊敬的用戶',
    Expire1: '使用時間即將到期，到期時間',
    Expire2: '請即時聯系平台運維工作人員',
    repeatAddition: '自定義顏色重復添加',
    quickAdd: '快速新增',

    switchcompanies: '切換',
    myapp: '我的應用',
    createapplication: '創建應用',
    helpcenter: '幫助中心',
    mobileterminaluse: '移動端使用',
    helpdocument: '幫助文檔',
    technicalsupport: '技術支持',
    applicationcenter: '應用中心',
    updatelog: '更新日誌',
    requirementsfeedback: '需求反饋',
    productevaluation: '產品評價',
    turnonlevitationbutton: '開啟懸浮按鈕',
    layoutsettings: '布局設置',
    skinsettings: '皮膚設置',
    selectskin: '選擇皮膚',
    custom: '自定義',
    selectskinTip: '建議使用1920*1024尺寸圖片',
    teamfacegivesyoumoreoptions: '給妳更多選擇',
    youcanuseteamfaceonmobileinthefollowingway: '您可以通過以下幾種方式在移動端使用',
    teamfacewechatservicenumber: '微信服務號',
    scancodetofollowTip: '掃碼關註公眾號在微信中使用系統',
    scancodetofollowTip2: '關註公眾號登錄系統',
    integrationintothirdpartyapp: '集成到第三方應用',
    applyfortrial: '申請試用',
    toconsultcustomerservice: '掃碼咨詢微信客服',
    callforinformation: '咨詢電話',
    needanothermobilesolutio: '需要其他移動端方案？請點擊告訴我們',
    renewalalert: '續費提醒',
    dearuseryourservicehasexpire:
      '尊敬的用戶，您的服務已到期。如需繼續使用請及時續費或來電咨詢，續費後可正常使用。',
    totalsystemquantitytotalspace: '系統數量總量/空間總量',
    upto90: '已達90%',
    rechargeassoonaspossibleTip: '請盡快充值，避免因為數量不足導致業務數據無法新建保存成功',
    pay: '支付',
    yuandelayedbyoneday: '元延期壹天',
    renewimmediatelyperyear: '立即續費（按年）',
    selectlayout: '選擇布局',
    selectpopover: '選擇彈窗',
    renewalperiod: '續費年限',
    platformmessages: '平臺消息',
    upgradealert: '升級提醒',
    laterversion: '更新版本',
    updatecontent: '更新內容：',
    isee: '我知道了',
    sideshot: '側彈',
    popover: '彈窗',
    fullscreenpopover: '全屏彈窗',
    classicnavigation: '經典導航式',
    simplenavigation: '簡約導航式',
    traditionalnavigation: '傳統導航式',
    traditionalfunctional: '傳統職能式',
    sidebarnavigation: '側欄導航式',
    sidebarfunctional: '側欄職能式',
    customerexpirationdate: '客戶使用時間到期',
    backofficemanagement: '後臺管理',
    workbenchmanage: '門戶管理',
    approvalmanage: '審批管理',
    projectmanage: '項目管理',
    emailmanage: '郵件管理',
    reportmanage: '數據報表',
    attendancemanage: '考勤管理',
    salarymanage: '薪酬管理',
    repositorymanage: '知識庫管理',
    filelibrarymanage: '文件庫管理',
    appmanage: '應用管理',
    num1: 'a111',
    selectcompanyindustry: '選擇機構所在行業',
    industryofthecompany: '機構所屬行業',
    selectsystemtouse: '選擇使用系統',
    nextstep: '下壹步',
    gotoappmarket: '前往應用市場',
    seemoreapps: '查看更多應用',
    backup: '上壹步',
    nofindasuitableapplicatio: '沒有找到合適的應用？快去',
    createmanually: '手動創建',
    bar: '吧~',
    clicktousetheapp: '點擊進入使用應用',
    oneclicktoinstallanduseapps: '點擊壹鍵安裝使用應用',
    totalrequirementsgathering: '全部需求收集',
    newdata: '新增數據',
    moreoperations: '更多操作',
    batchimportdata: '批量導入數據',
    step1: '1/3 模塊列表頭部操作',
    step2: '2/3 模塊列表標題欄操作',
    step3: '3/3 添加子菜單操作',
    customerowner: '客戶所有人',
    customername: '客戶名稱',
    totalnumber: '總人數',
    industry: '所屬行業',
    checkthefieldsyouwanttodisplay: '勾選您要顯示的字段',
    moveinandclickanddragcolumnwidth: '移入點擊拖動列寬',
    administratorcansavedraggedcolumnwidth: '管理員可保存拖動的列寬',
    clickautosort: '點擊自動排序',
    setlistdisplayfield: '設置列表顯示字段',
    filterlistdata: '篩選列表數據',
    addsubmenu: '添加子菜單',
    addedsubmenu: '添加的子菜單',
    whaticareabout: '我關註的',
    addenterpriseapplications: '添加企業應用',
    enterpriseapplicationcenter: '企業應用中心',
    alltradesandoccupationsreadytouse: '各行各業即裝即用',
    createblankapplication: '創建空白應用',
    buildwhateveryouwant: '隨心所欲搭建',
    enterprisecustomization: '企業私有定制',
    professionalconsultantscustomised: '專業顧問個性化定制',
    underinstallation: '安裝中…',
    customerrelationshipmanagement: '客戶關系管理',
    hrhumanresourcesystem: 'HR人力資源系統',
    srmsupplierrelationshipmanagementsystem: 'SRM供應商關系管理系統',
    invoicingmanagement: '進銷存管理',
    environmentalengineering: '環保工程',
    propertymanagementsystem: '物業管理系統',
    batchmodification: '批量修改',
    founder: '創建人',
    createtime: '創建時間',
    ordernumber: '訂單號',
    department: '所屬部門',
    belongingnumber: '所屬編號',
    contractname: '合同名稱',
    contractnumber: '合同編號',
    contractpartya: '合同甲方',
    personinchargeofpartya: '甲方負責人',
    companyindustry_empty: '機構所屬行業不能為空',
    systemtouse_empty: '請選擇使用系統',
    scan_download: '掃碼下載',
    also: '還可以',
    appapply: '手機應用',
    complaintsSuggestions: '投訴建議',
    EnterpriseBackgroundSetting: '系統後臺設置',
    AppNav: '應用導航',
    mouseDragSort: '按住鼠標不放，拖延可調整順序',
    noResultsReceived: '暫未收到相關結果',
    appSetting: '應用設置',
    portalSetting: '門戶設置',
    KnowledgeSetting: '知識庫設置',
    librarySetting: '文件庫設置'
  }
}
